import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import * as moment from 'moment';
import { Modal, Row, Col, Input } from 'antd';
import Form, { FormItem } from '../../../components/Form';

interface IInvoiceDetailProps {
  invoice: GQL.IInvoice;
  updateInvoice?: MutationFunc;
  onSubmit: () => void;
  onCancel: () => void;
}

interface IInvoiceDetailState {
  data: {
    invoiceDate: string;
    dueDate: string;
    taxableDate: string;
  };
}

class InvoiceDetail extends React.Component<IInvoiceDetailProps, IInvoiceDetailState> {

  private form;

  public constructor(props: IInvoiceDetailProps) {
    super(props);

    const { invoice } = props;

    this.state = {
      data: {
        invoiceDate: this.parseDate(invoice.invoiceDate),
        dueDate: this.parseDate(invoice.dueDate),
        taxableDate: this.parseDate(invoice.taxableDate),
      },
    };
  
    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  private parseDate(date) {
    return date ? moment(new Date(date)).format('YYYY-MM-DD') : '';
  }

  public render() {
    const { data } = this.state;

    return (
      <Modal
        title={'Invoice edit'}
        visible={true}
        width={'30%'}
        okText={'Save changes'}
        onOk={this.onSubmit}
        onCancel={this.props.onCancel}
        destroyOnClose={true}
        maskClosable={false}

      >
        <Form
          ref={f => this.form = f}
          displayFooter={false}
          onSubmit={() => alert('onSubmit')}
          onCancel={() => alert('onCancel')}
        >
          <Row gutter={15}>
            <Col span={24}>
              <FormItem label={'Invoice date'} required={true}>
                <Input
                  type={'date'}
                  name={'invoiceDate'}
                  value={data.invoiceDate || ''}
                  required={true}
                  autoFocus={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Due date'} required={true}>
                <Input
                  type={'date'}
                  name={'dueDate'}
                  value={data.dueDate || ''}
                  required={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Taxable date'} required={true}>
                <Input
                  type={'date'}
                  name={'taxableDate'}
                  value={data.taxableDate}
                  required={true}
                  onChange={this.onChange}
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }

  private onChange(e: any) {
    const { name, value, checked } = e.target;

    const inputValue = value !== null && value !== undefined ? value : checked;

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate() && this.props.updateInvoice) {
        this.props.updateInvoice({
          variables: {
            id: this.props.invoice.id,
            data: { ...this.state.data }
          }
        })
          .then((result) => {
            if (result && result.data && result.data.updateInvoice) {
              this.props.onSubmit();
            }
          });
      }
    }
  }
}

export default InvoiceDetail;


// WEBPACK FOOTER //
// ./src/scenes/Invoice/InvoiceDetail/InvoiceDetail.tsx